let config = [{
        "key": "tips",
        "value": "查看配置示例",
        "type": "tips"
    },
    {
        "name": "达标返",
        "type": "module-name"
    },
    {
        "key": "link_data",
        "name": "选择奖励规则",
        "type": "select-rule"
    },
    {
        "key": "property_data",
        "name": "属性",
        "type": "custom",
        "content": [{
                "key": "bjzs_color",
                "name": "背景主色",
                "type": "color"
            },
            {
                "key": "bjfzs_color",
                "name": "背景辅助色",
                "type": "color"
            },
            {
                "key": "smwa_color",
                "name": "说明文案颜色",
                "type": "color"
            },
            {
                "key": "tcwa_color",
                "name": "突出文案颜色",
                "type": "color"
            },
            {
                "key": "tcwabj_color",
                "name": "突出文案背景色",
                "type": "color"
            },
            {
                "key": "smwabj_color",
                "name": "说明文案背景色",
                "type": "color"
            },
            {
                "key": "cywabj_color",
                "name": "次要文案背景色",
                "type": "color"
            },
            {
                "key": "jdtbj_color",
                "name": "进度条背景色",
                "type": "color"
            },
            {
                "key": "jdt_color",
                "name": "进度条色",
                "type": "color"
            },
            {
                "key": "yr_header_text",
                "name": "预热期头部",
                "type": "text",
                "memo": "预热期头部文案",
                "max": 16
            },
            {
                "key": "yr_footer_text",
                "name": "预热期底部",
                "type": "text",
                "memo": "预热期底部文案",
                "max": 20
            },
            {
                "key": "rule_color",
                "name": "活动规则颜色",
                "type": "color"
            },
            {
                "key": "rule_text",
                "name": "活动规则",
                "type": "text",
                "memo": "活动规则文案",
                "max": 26
            },
            {
                "key": "rule_link",
                "name": "活动规则链接",
                "type": "link",
                "memo": "活动规则链接",
                "max": 26
            },
        ],
    },
];
export default config;